import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'

export function generatePdf(cadastros) {
  let title_pdf = 'Cidadão'
  let titlePdfSave = utils.methods.titlePdf('Cidadão')
  let description_pdf = 'Dados do cidadão (Imprimir cartão SUS, equipe e ACS)'
  let headers_pdf = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'MC',
    'PROFISSIONAL ACS',
    'EQUIPE',
    'DOCUMENTO',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.no_mae = cadastros[i].no_mae
    obj.micro_area = cadastros[i].micro_area
    obj.profissional_acs = cadastros[i].no_profissional
    obj.equipe = cadastros[i].no_unidade_saude
    let documentoText = ''
    if (cadastros[i].nu_cpf) {
      documentoText += `CPF ${cadastros[i].nu_cpf}`
    }
    if (cadastros[i].nu_cns) {
      documentoText += `\nCNS ${cadastros[i].nu_cns}`
    }
    obj.documento = documentoText
    data_pdf.push(obj)
  }
  let doc = new jsPDF(utils.methods.encryptionPdf())
  let rows = []
  for (let i = 0; i < data_pdf.length; i++) {
    rows[i] = Object.values(data_pdf[i])
  }
  let table = []
  for (var i = 0; i < rows.length; i++) {
    var tableRow = rows[i]
    for (var i = 0; i < rows.length; i++) {
      var tableRow = rows[i]
      var rowData = []
      if (tableRow.length != 0) {
        for (var j = 0; j < tableRow.length; j++) {
          rowData.push(tableRow[j])
        }
      } else {
        continue
      }
      table.push(rowData)
    }
  }
  let verticalPosition = 20
  doc.setFontSize(18)
  doc.text(title_pdf, 105, verticalPosition, null, null, 'center')
  verticalPosition += 7
  doc.setFontSize(14)
  doc.text(description_pdf, 105, verticalPosition, null, null, 'center')
  verticalPosition += 14
  doc.text(
    'Município: ' + store.state.cidade,
    15,
    verticalPosition,
    null,
    null,
    'left'
  )
  verticalPosition += 3
  doc.autoTable({
    head: [headers_pdf],
    body: table,
    headStyles: {
      fillColor: '#ccc',
      fontSize: 6,
      textColor: '#000',
      halign: 'center',
      cellWidth: 'wrap',
    },
    bodyStyles: {
      halign: 'center',
      fontSize: 6,
    },
    theme: 'striped',
    startY: verticalPosition,
    showHead: 'firstPage',
  })

  doc.save(titlePdfSave + '.pdf')

  vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
    position: 'topRight',
  })
}

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
  Profissional: 'no_profissional',
  Equipe: 'no_unidade_saude',
}
